<template>
  <!--
  <div>
    <div class="row">
      <div class="col-md-12" style="text-align: center; color: black !important; font-weight: bold; font-size: 20px">
        <br />
        Formulário de proposta de parcelamento
        <br />
        LOTE {{ proposta.lote_numero }} - {{ proposta.lote_titulo }}
        <br />
        LEILÃO ID {{ proposta.leilao_id }}
        <br />
      </div>
    </div>
    <div class="card">
      <div class="card-body table-responsive p-0">
        <table class="table table-hover" style="position: relative; font-size: 18px">
          <thead>
            <tr></tr>
          </thead>
          <tbody>
            <tr>
              <td style="width: 250px; min-width: 250px !important; font-weight: bold">DATA DA PROPOSTA</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">
                {{ formatDate(proposta.created_at) }}
              </td>
            </tr>
            <tr>
              <td style=" font-weight: bold">AUTOS</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">AUTOS</td>
            </tr>
            <tr>
              <td style=" font-weight: bold">VARA/CIDADE</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">{{ proposta.processo_vara }} - {{ proposta.cidade_processo }}</td>
            </tr>
            <tr>
              <td style=" font-weight: bold">DATA LEILÃO</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">
                {{ formatDate(proposta.data_leilao) }}
              </td>
            </tr>
            <tr>
              <td style=" font-weight: bold">PRAÇA</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">
                {{ proposta.praca }}
              </td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">DESCRIÇÃO DO BEM</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">
                <div v-html="proposta.lote_descricao"></div>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">VALOR DO BEM EM LEILÃO</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">R$ {{ toCurrency(proposta.valor_bem) }}</td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">VALOR DA PROPOSTA</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">R$ {{ toCurrency(proposta.valor_proposta) }}</td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">% DE ENTRADA</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">
                {{ formatarComissao(proposta.pct_entrada) }}% (R$ {{ toCurrency(proposta.valor_entrada) }})
              </td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">QTD PARCELAS</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">{{ proposta.parcelas }}x</td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">VALOR DA PARCELA</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">R$ {{ calcularParcela() }}</td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">COMISSÃO DO LEILOEIRO</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">{{ formatarComissao(proposta.lote_comissao) }}%</td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">INDICE DE CORREÇÃO</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">{{ proposta.indice }}</td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">PROPONENTE</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">
                {{ proposta.nome }} - {{ proposta.profissao }}- {{ getEstadoCivil(proposta.estado_civil) }} - CPF: {{ proposta.cpf }} - RG:
                {{ proposta.rg }}
              </td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">ENDEREÇO</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">
                {{ proposta.endereco }} - {{ proposta.endereco_num }}- {{ proposta.endereco_bairro }} - CEP:
                {{ proposta.endereco_cep }} - {{ proposta.cidade }} / {{ proposta.estado }}
              </td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">CONTATO</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">{{ proposta.telefone_fixo }} - Celular:&nbsp;{{ proposta.telefone_celular }}</td>
            </tr>
            <tr>
              <td style="vertical-align: center; font-weight: bold">E-MAIL</td>
              <td data-label="URL"class="normal-td"  style="border: 1px solid; border-top: none; border-left: none">{{ proposta.email }}</td>
            </tr>
          </tbody>
        </table>

        <div style="margin-top: 15px; line-height: 20px; font-size: 18px">
          <p style="font-weight: bold">A presente proposta não garante o lance, sendo necessário a confirmação do mesmo no auditório online.</p>
          <p>OBS: Sempre prevalecerá o lance para pagamento À VISTA;</p>
          <p>
            O valor do bem poderá ser atualizado no momento do leilão, conforme previsto em edital; O pagamento referente à comissão do Leiloeiro é de
            responsabilidade do Arrematante.
          </p>
        </div>
      </div>
    </div>

    <div class="row" style="width: 100%">
      <div clas="col-sm-6" style="padding: 5%; text-align: center; line-height: 10px">
        <p>__________________________________________________</p>
        <p>{{ proposta.nome }}</p>
        <p>CPF:{{ proposta.cpf }}</p>
      </div>
      <div clas="col-sm-6" style="padding: 5%; text-align: center; line-height: 10px">
        <p>___________________________________________________</p>
        <p>ANTÔNIO MAGNO JACOB DA ROCHA</p>
        <p>Leiloeiro oficial</p>
      </div>
    </div>

    <div style="width: 100%; text-align: center; line-height: 10px; font-size: 18px">
      <p>R. Augusto Zibarth, 994 - Curitiba/PR</p>
      <p>documentos@rochaleiloes.com.br - (41) 3077-8880</p>
    </div>
  </div>
  -->
  <div id="printMe" ref="document" style="margin-top: 0px">
    <div class="row">
      <div class="col-md-12 title" style="text-align: center; font-weight: bold; font-size: 12px">
        <img alt="Avatar" class="table-avatar" style="width: 150px; opacity: 0.8" src="/images/logo.png" />
        <p style="margin-top: 3px; text-transform: uppercase; position: relative" class="title">
          Formulário de proposta de
          <span v-if="proposta.tipo == 'venda'">compra em venda direta</span>
          <span v-else>parcelamento</span>

          <span style="color: red; position: absolute; right: 0" v-if="proposta.deleted_at">
            Proposta revogada em {{ formatDate(proposta.deleted_at) }}
          </span>
        </p>
        <p style="text-transform: uppercase">LOTE {{ proposta.lote_numero }} - {{ proposta.lote_titulo }}</p>
        <p style="text-transform: uppercase">LEILÃO ID {{ proposta.leilao_id }}</p>
      </div>
    </div>
    <div class="card" style="font-size: 12px">
      <div class="card-body table-responsive p-0" style="font-size: 12px; padding-top: 1px !important">
        <table class="table table-hover" style="position: relative; font-size: 18px; font-size: 12px">
          <thead>
            <tr></tr>
          </thead>
          <tbody style="line-height: 5px">
            <tr style="margin: 0px 0px 0px 0px">
              <td style="border: 1px solid; width: 250px; min-width: 250px !important; font-weight: bold">DATA E HORA DA PROPOSTA</td>
              <td style="border: 1px solid; border-left: none" data-label="URL">
                {{ formatDate(proposta.created_at) }}
              </td>
            </tr>
            <tr v-if="proposta.leilao_tipo == 'judicial'">
              <td style="border: 1px solid; border-top: none; font-weight: bold; line-height: 15px !important">PROCESSO</td>
              <td
                style="border: 1px solid; border-top: none; border-left: none; text-transform: uppercase; line-height: 15px !important"
                data-label="URL"
              >
                {{ proposta.processo_numero }} - {{ proposta.processo_vara }} - {{ proposta.cidade_processo }} / {{ proposta.estado_processo_sigla }}
              </td>
            </tr>
            <tr v-if="proposta.leilao_tipo == 'judicial' && proposta.tipo == 'parcelamento'">
              <td style="border: 1px solid; border-top: none; font-weight: bold">PRAÇA</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none">{{ proposta.praca }}º PRAÇA</td>
            </tr>
            <tr v-if="proposta.leilao_tipo == 'judicial' && proposta.tipo == 'parcelamento'">
              <td style="border: 1px solid; border-top: none; font-weight: bold">DATA E HORA DO INÍCIO PRAÇA</td>
              <td style="border: 1px solid; border-top: none; border-left: none; text-transform: uppercase" data-label="URL">
                {{ getDataPraca() }}
              </td>
            </tr>
            <tr>
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold; line-height: 15px">DESCRIÇÃO DO BEM</td>
              <td
                data-label="URL"
                style="border: 1px solid; border-top: none; border-left: none; padding-bottom: 0px; margin-bottom: 0px; line-height: 15px !important"
              >
                <!-- <label v-html="proposta.lote_descricao"></label> -->
                <label style="font-weight: 400; font-size: 12px; text-transform: uppercase">
                  {{ formatarHTML(proposta.lote_descricao) }}
                </label>
              </td>
            </tr>
            <tr v-if="proposta.leilao_tipo == 'judicial' && proposta.tipo == 'parcelamento'">
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold">VALOR DO BEM EM LEILÃO</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none">R$ {{ toCurrency(proposta.valor_bem) }}</td>
            </tr>
            <tr v-if="proposta.leilao_1_modalidade == 'venda'">
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold">VALOR MÍNIMO PARA ALIENAÇÃO</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none">R$ {{ toCurrency(proposta.valor_bem) }}</td>
            </tr>
            <tr>
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold">VALOR DA PROPOSTA</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none">R$ {{ toCurrency(proposta.valor_proposta) }}</td>
            </tr>
            <tr v-if="proposta.tipo == 'venda' && proposta.leilao_tipo == 'extra'">
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold; line-height: 15px !important">
                FORMA DE PAGAMENTO
              </td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none; line-height: 15px !important">
                {{ proposta.observacao }}
              </td>
            </tr>
            <tr v-if="proposta.parcelas > 1">
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold">PERCENTUAL DE ENTRADA</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none">{{ formatarComissao(proposta.pct_entrada) }}%</td>
            </tr>
            <tr v-if="proposta.parcelas > 1">
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold">QUANTIDADE DE PARCELAS</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none">{{ proposta.parcelas }}</td>
            </tr>
            <tr v-if="proposta.parcelas > 1">
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold">VALOR APROXIMADO DA PARCELA</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none">R$ {{ calcularParcela() }}</td>
            </tr>
            <tr v-if="proposta.parcelas > 1">
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold">ÍNDICE DE CORREÇÃO</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none">{{ proposta.indice }}</td>
            </tr>
            <tr>
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold">COMISSÃO DO LEILOEIRO</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none">{{ formatarComissao(proposta.lote_comissao) }}%</td>
            </tr>
            <tr>
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold; line-height: 15px">PROPONENTE</td>
              <td
                data-label="URL"
                style="text-transform: uppercase; border: 1px solid; border-top: none; border-left: none; line-height: 15px !important"
              >
                {{ proposta.nome }} - {{ proposta.profissao }} - {{ getEstadoCivil(proposta.estado_civil) }} - CPF: {{ formatarCPF(proposta.cpf) }} -
                RG:
                {{ proposta.rg }}
              </td>
            </tr>
            <tr>
              <td
                style="text-transform: uppercase; border: 1px solid; border-top: none; vertical-align: center; font-weight: bold; line-height: 15px"
              >
                ENDEREÇO
              </td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none; margin-top: 0px; line-height: 15px !important">
                {{ proposta.endereco }}, {{ proposta.endereco_num }} - {{ proposta.endereco_bairro }} - CEP: {{ proposta.endereco_cep }} -
                {{ proposta.cidade }} / {{ proposta.estado_sigla }}
              </td>
            </tr>
            <tr>
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold; line-height: 15px !important">TELEFONES</td>
              <td data-label="URL" style="border: 1px solid; border-top: none; border-left: none; line-height: 15px !important">
                Fone: {{ formatarTelefone(proposta.telefone_fixo) }} - Celular:&nbsp;{{ formatarTelefone(proposta.telefone_celular) }}
              </td>
            </tr>
            <tr>
              <td style="border: 1px solid; border-top: none; vertical-align: center; font-weight: bold">E-MAIL</td>
              <td style="border: 1px solid; border-top: none; border-left: none" data-label="URL">{{ proposta.email }}</td>
            </tr>
          </tbody>
        </table>

        <div style="margin-top: 5px; font-size: 12px; text-align: center" v-if="proposta.tipo == 'parcelamento'">
          <span style="font-weight: bold; color: red">ATENÇÃO:</span>
          <br />
          <span style="font-weight: bold">A presente proposta não garante o lance, sendo necessário a confirmação do mesmo no auditório online;</span>
          <br />
          <span style="font-weight: bold">Sempre prevalecerá o lance para pagamento À VISTA;</span>
          <br />
          <span style="font-weight: bold">O valor do bem poderá ser atualizado no momento do leilão, conforme previsão no Edital;</span>
          <br />
          <span style="font-weight: bold">
            O pagamento referente à comissão do Leiloeiro é de responsabilidade do Arrematante e não está inclusa no valor do lance.
          </span>
          <br />
          <br />
        </div>

        <div style="margin-top: 5px; font-size: 12px; text-align: center" v-else-if="proposta.tipo == 'venda' && proposta.leilao_tipo == 'extra'">
          <span style="font-weight: bold">
            O proponente manifesta ciência das informações contidas no site, tal como, requer o envio da presente proposta para apreciação do
            vendedor, comprometendo-se a realizar os pagamentos aqui previstos em caso de aceite da mesma, sob pena de bloqueio permanente do
            cadastro.
          </span>
          <br />
          <br />
        </div>

        <div style="margin-top: 5px; font-size: 12px; text-align: center" v-else-if="proposta.tipo == 'venda' && proposta.leilao_tipo == 'judicial'">
          <span style="font-weight: bold">
            O proponente manifesta ciência das informações contidas no Edital publicado, tal como, requer a juntada da presente proposta nos
            respectivos autos para apreciação, comprometendo-se a realizar os pagamentos aqui previstos em caso de deferimento da mesma, sob pena de
            bloqueio permanente do cadastro.
          </span>
          <br />
          <br />
        </div>
      </div>
    </div>
    <div class="row" style="text-align: center; width: 100%; min-width: 100%; font-size: 12px; line-height: 12px; margin-left: 0px">
      <div clas="col-md-6" style="width: 50%; padding: 5%; text-align: center; font-size: 12px">
        <p>___________________________________________________</p>
        <span>{{ proposta.nome }}</span>
        <br />
        <span style="margin-top: 5px">CPF: {{ formatarCPF(proposta.cpf) }}</span>
      </div>
      <div clas="col-md-6" style="width: 50%; padding: 5%; text-align: center; font-size: 12px">
        <p>___________________________________________________</p>
        <span>ANTÔNIO MAGNO JACOB DA ROCHA</span>
        <br />
        <span style="margin-top: 5px">LEILOEIRO OFICIAL - JUCEPAR nº 08/020-L</span>
      </div>
    </div>

    <div style="width: 100%; text-align: center; line-height: 12px; font-size: 18px; font-size: 12px">
      <span>R. Augusto Zibarth, 994 - Curitiba/PR</span>
      <br />
      <span>documentos@rochaleiloes.com.br - (41) 3077-8880</span>
    </div>
  </div>

  <div class="card-footer">
    <button
      v-if="!is_pagina_proposta"
      style="margin-left: 5px"
      data-dismiss="modal"
      aria-hidden="true"
      @click="visualizar_proposta = false"
      class="btn btn-danger"
    >
      Fechar
    </button>
    <button style="margin-left: 5px" data-dismiss="modal" aria-hidden="true" @click="exportToPDF" class="btn btn-primary">
      Salvar
      <i style="margin-left: 5px" class="fa-solid fa-file-pdf"></i>
    </button>
    <button style="margin-left: 5px" data-dismiss="modal" aria-hidden="true" @click="print" class="btn btn-info">
      Imprimir
      <i style="margin-left: 5px" class="fa-solid fa-print"></i>
    </button>
    <button
      style="margin-left: 5px; background-color: #007fff; border-color: #007fff"
      data-dismiss="modal"
      aria-hidden="true"
      @click="exportToWord"
      class="btn btn-info"
    >
      Word
      <i class="fa-solid fa-file"></i>
    </button>
  </div>
</template>

<script>
import sweetAlert from "../controller/sweetAlert";
import auxFormatacao from "../controller/auxFormatacao";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import currencyController from "../controller/currencyController";
//import html2pdf from "html2pdf.js";

import htmlDocx from "html-docx-js/dist/html-docx.js";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  props: ["proposta"],

  mixins: [sweetAlert, Swal, AuxController, currencyController, auxFormatacao],

  //components: [Loading, html2pdf],
  components: [Loading],

  data() {
    return {
      isLoading: false,
      proposta_selecionada: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      propostas: [],
      cidades: [],
      id: "",
      estado: "",
      cidade: "",
      comitente: "",
      titulo: "",
      descricao: "",
      local: "",
      tipo: "",
      teste: 0,
      executado: "",
      processo: "",
      is_pagina_proposta: false,
    };
  },

  mounted() {
    console.log("Mounted proposta");
    console.log(this.proposta);

    this.is_pagina_proposta = window.location.pathname.includes("/proposta/" + this.proposta.hash);

    console.log("IS? " + this.is_pagina_proposta);
  },

  methods: {
    getDataPraca() {
      if (this.proposta.praca == 1) {
        return this.formatDate(this.proposta.leilao_1_data);
      } else if (this.proposta.praca == 2) {
        return this.formatDate(this.proposta.leilao_2_data);
      } else if (this.proposta.praca == 3) {
        return this.formatDate(this.proposta.leilao_3_data);
      } else if (this.proposta.praca == 4) {
        return this.formatDate(this.proposta.leilao_4_data);
      }
    },

    print() {
      const options = {
        name: "_blank",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: ["https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css", "https://unpkg.com/kidlat-css/css/kidlat.css"],
        timeout: 1000, // default timeout before the print window appears
        autoClose: true, // if false, the window will not close after printing
        windowTitle: window.document.title, // override the window title
      };

      //htmlToPaper("printMe");

      this.$htmlToPaper("printMe", options);
    },

    formatarHTML(valor) {
      console.log("Valor antes");
      console.log(valor);

      if (typeof valor == "string" && valor.includes("</")) {
        console.log("Entrou no IF");
        var div = document.createElement("div");
        div.innerHTML = valor;
        valor = div.textContent || div.innerText || "";
      }
      console.log("Valor depois");
      console.log(valor);

      return valor;
    },

    async exportToPDF() {
      /*
      html2pdf(this.$refs.document, {
        margin: 0.2,
        filename: "document.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      });
      */

      this.isLoading = true;
      const reportElement = this.$refs.document;

      if (!reportElement) {
        this.isLoading = false;
        this.showErrorMessageWithButton("Ops...", "Elemento do relatório não encontrado.");
        return;
      }

      // Adiciona a classe de estilos para o PDF
      reportElement.classList.add("pdf-render-view");

      try {
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "pt",
          format: "letter",
        });

        await pdf.html(reportElement, {
          html2canvas: {
            scale: 0.75, // Ponto de partida para o zoom. Ajuste se necessário.
            useCORS: true,
          },
          autoPaging: "text",
          x: 20,
          y: 20,
          width: 572, // Largura de uma página letter (612pt) - margens (2*20pt)
          windowWidth: 800, // Simula uma janela maior para o layout
        });

        // Usa o número do lote para um nome de arquivo único
        pdf.save(`proposta-lote-${this.proposta.lote_numero}.pdf`);
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
        this.showErrorMessageWithButton("Erro", "Não foi possível gerar o PDF.");
      } finally {
        // Remove a classe de estilos após a geração
        reportElement.classList.remove("pdf-render-view");
        this.isLoading = false;
      }
    },

    exportToWord() {
      const content = document.getElementById("printMe"); // O ID do seu HTML

      // Verifique se o elemento existe
      if (!content) {
        console.error("Elemento com ID 'printMe' não encontrado.");
        return;
      }

      // Limpeza do HTML - remove qualquer conteúdo não necessário como scripts ou estilos
      let html = content.outerHTML;
      html = html.replace(/<script[^>]*>(.*?)<\/script>/g, ""); // Remove qualquer <script> do HTML
      html = html.replace(/<style[^>]*>(.*?)<\/style>/g, ""); // Remove qualquer <style> do HTML

      // Converter a logo para Base64
      this.convertImageToBase64(process.env.MIX_VUE_APP_URL + "/images/logo.png", (base64Image) => {
        // Substitua a URL da logo no HTML pela string Base64
        html = html.replace('src="' + process.env.MIX_VUE_APP_URL + "/images/logo.png" + '"', `src="${base64Image}"`);

        // Garantir que o HTML tenha a codificação UTF-8 corretamente aplicada
        html = `<meta charset="UTF-8">${html}`;

        // Converte para Blob no formato Word
        const converted = htmlDocx.asBlob(html);

        // Garantir que o tipo do arquivo seja 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        const link = document.createElement("a");
        link.href = URL.createObjectURL(converted);
        link.download = "documento.docx"; // Nome do arquivo de download
        link.type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"; // Definir o tipo do arquivo
        link.click(); // Aciona o download
      });
    },

    // Função para converter imagem para Base64
    convertImageToBase64(imageUrl, callback) {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result); // Retorna o Base64 da imagem
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", imageUrl, true);
      xhr.responseType = "blob";
      xhr.send();
    },

    formatarComissao(texto) {
      if (texto) {
        return this.toCurrency(texto);

        /*
        if (typeof texto == "string" && texto.includes(".")) {
          console.log("PRIMEIRO IF");
          return this.replaceAll(texto, ".", ",");
        } else {
          return texto + ",00";
        }
          */
      } else {
        return texto;
      }
    },

    replaceAll(string, search, replace) {
      if (string && typeof string == "string") {
        return string.split(search).join(replace);
      } else {
        return string;
      }
    },

    calcularParcela() {
      if (this.proposta.tipo == "parcelamento" || this.proposta.parcelas >= 1) {
        let valor_proposta = Number(this.toNumber(this.proposta.valor_proposta));
        let valor_entrada = (Number(this.toNumber(this.proposta.pct_entrada)) * valor_proposta) / 100;

        return this.toCurrency((valor_proposta - valor_entrada) / this.proposta.parcelas);
      } else {
        return "0,00";
      }
    },

    getEstadoCivil(estado_civil) {
      if (estado_civil == "divorciado") {
        return "divorciado";
      }

      if (estado_civil == "separado_judicialmente") {
        return "Separado judicialmente";
      }

      if (estado_civil == "casado") {
        return "Casado";
      }

      if (estado_civil == "viuvo") {
        return "Viuvo";
      }

      if (estado_civil == "solteiro") {
        return "Solteiro";
      }
      if (estado_civil == "solteiro_com_uniao_estavel") {
        return "Solteiro com união estável";
      }
      if (estado_civil == "solteiro_sem_uniao_estavel") {
        return "Solteiro sem união estável";
      }
      if (estado_civil == "uniao_estavel") {
        return "União estável";
      }
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, proposta) {
      this.proposta_selecionada = proposta;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 150;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    changeStatus(leilao, atual) {
      console.log(leilao);

      let data = {
        leilao_id: leilao.id,
        leilao_retirado: this.convertToTiny(leilao.leilao_retirado),
        leilao_encerrado: this.convertToTiny(leilao.leilao_encerrado),
        leilao_suspenso: this.convertToTiny(leilao.leilao_suspenso),
      };

      console.log(data);

      axios
        .post(`/admin/leilao/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(proposta) {
      this.proposta_selecionada = proposta;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarPropostas();
      }
    },

    buscarPropostas() {
      this.isLoading = true;

      let data = {
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log(data);

      axios
        .post(`/admin/propostas/search`, data)
        .then((response) => {
          this.propostas = response.data.propostas;
          this.total = response.data.total;

          console.log("Leilões");
          console.log(this.propostas);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarPropostas();
    },

    deletar(leilao) {
      this.leilao_selecionado = leilao;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja prosseguir?? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.leilao_selecionado.id,
            };

            axios
              .post(`/admin/proposta/delete`, data)
              .then((response) => {
                this.showSuccessMessage("Proposta deletada!");

                this.buscarPropostas();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },
  },
};
</script>

<style>
/* Estilos gerais para a renderização do PDF deste relatório */
.pdf-render-view {
  font-family: Arial, sans-serif;
  font-size: 7pt;
  line-height: 1.5;
  color: #212529; /* Cor de texto padrão (preto suave) */
}

/* --- CABEÇALHO --- */
.pdf-render-view .col-md-12[style*="text-align: center"] {
  text-align: center !important;
  margin-bottom: 10pt !important;
}
.pdf-render-view .col-md-12[style*="text-align: center"] img {
  width: 100px !important;
  display: block !important;
  margin: 0 auto 10pt auto !important;
}
.pdf-render-view .col-md-12[style*="text-align: center"] p {
  font-size: 7pt !important;
  font-weight: bold;
  margin: 2pt 0 !important;
}

/* --- TABELA PRINCIPAL --- */
.pdf-render-view table {
  width: 100% !important;
  border-collapse: collapse !important; /* Remove espaços entre as bordas das células */
  margin-bottom: 10pt !important;
}

.pdf-render-view table td {
  padding: 8pt 6pt !important;
  line-height: 1.2 !important;
  border: 1px solid #dee2e6 !important; /* Borda cinza claro e consistente */
  vertical-align: top !important; /* Alinha o conteúdo ao topo da célula */
}

/* Estiliza a coluna de etiquetas (primeiro <td> de cada linha) */
.pdf-render-view table tr td:first-child {
  font-size: 10px !important;
  font-weight: bold !important;
  background-color: #f8f9fa; /* Fundo cinza bem claro para diferenciar */
  width: 100pt !important; /* Largura fixa para alinhar verticalmente */
}

/* --- TEXTOS DE OBSERVAÇÃO --- */
.pdf-render-view div[style*="margin-top: 5px"] {
  /* 1. Alinhamento do TEXTO INTERNO */
  text-align: center !important;

  /* 2. Centralização do BLOCO (a div) */
  display: block !important; /* Garante que o elemento se comporte como um bloco */
  width: 90% !important; /* Define uma largura (ex: 90% da página) */
  margin-left: auto !important; /* Margem automática para centralizar */
  margin-right: auto !important; /* Margem automática para centralizar */

  /* Estilos adicionais */
  font-size: 7pt !important;
}

/* --- SEÇÃO DE ASSINATURAS --- */
.pdf-render-view .row[style*="text-align: center"] {
  margin-top: -20px !important;
  display: flex !important;
  justify-content: space-around !important;
  width: 100% !important;
  page-break-inside: avoid !important; /* Tenta evitar que a assinatura quebre entre páginas */
}
.pdf-render-view div[clas="col-md-6"] {
  width: 45% !important; /* Controla a largura de cada coluna de assinatura */
  text-align: center !important;
  line-height: 1 !important;
  font-family: 12px !important;
}

/* --- RODAPÉ FINAL --- */
.pdf-render-view div[style*="width: 100%; text-align: center;"] {
}
</style>

<style scoped>
.normal-td {
  border: 1px solid;
  border-bottom: none;
}

.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}

.printableArea {
  width: 20cm;
  height: 100%;
}

@page {
  size: 20cm auto;
  width: 20cm;
  height: 100%;
  margin: 0;
  margin-left: 200px !important;
}
</style>
